// Console override to suppress success logs and only show errors/warnings
// This file should be imported at the very top of index.js

const originalConsoleLog = console.log;
const originalConsoleInfo = console.info;
const originalConsoleDebug = console.debug;

// Check if we should suppress logs (can be controlled via localStorage for debugging)
const shouldSuppressLogs = () => {
    try {
        const suppressLogs = localStorage.getItem('SUPPRESS_SUCCESS_LOGS');
        // Default to true (suppress logs) unless explicitly set to '0' or 'false'
        return suppressLogs !== '0' && suppressLogs !== 'false';
    } catch {
        return true; // Default to suppressing logs
    }
};

// Override console.log to be silent (unless debugging is enabled)
console.log = (...args) => {
    if (!shouldSuppressLogs()) {
        originalConsoleLog.apply(console, args);
    }
};

// Override console.info to be silent (unless debugging is enabled)
console.info = (...args) => {
    if (!shouldSuppressLogs()) {
        originalConsoleInfo.apply(console, args);
    }
};

// Override console.debug to be silent (unless debugging is enabled)
console.debug = (...args) => {
    if (!shouldSuppressLogs()) {
        originalConsoleDebug.apply(console, args);
    }
};

// Keep console.warn and console.error unchanged - these will always show
// console.warn - shows warnings
// console.error - shows errors

// Export for potential debugging needs
export const enableDebugLogs = () => {
    try {
        localStorage.setItem('SUPPRESS_SUCCESS_LOGS', '0');
        console.warn('✅ Debug logs enabled. Refresh the page to see all console.log statements.');
    } catch {
        console.warn('Could not enable debug logs - localStorage unavailable');
    }
};

export const disableDebugLogs = () => {
    try {
        localStorage.setItem('SUPPRESS_SUCCESS_LOGS', '1');
        console.warn('🔇 Debug logs disabled. Only errors and warnings will be shown.');
    } catch {
        console.warn('Could not disable debug logs - localStorage unavailable');
    }
};

// Make these functions available globally for easy debugging in browser console
if (typeof window !== 'undefined') {
    window.enableDebugLogs = enableDebugLogs;
    window.disableDebugLogs = disableDebugLogs;
}
